import React from 'react';
import PropTypes from 'prop-types';
import styles from './MainContent.module.css';
import Loading from 'components/common/Loading';

const MainContent = ({ loading, children }) => {
  return (
    <>
      {loading ? (
        <Loading isLoadingAdminPage={true} />
      ) : (
        <div className={styles.mainContent}>{children}</div>
      )}
    </>
  );
};

MainContent.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
};

export default MainContent;
